<section class="w-full">
  <header class="l-flex l-align-y l-align-spaceBetween">
    <h2 class="t-widgetTitle">
      {{ clinic.clinicDescr }}
      <span class="fw-regular">({{ clinic.clinicId }})</span>
    </h2>
    <i class="fas fa-times t-popupCloseIcon" (click)="closePanel()"></i>
  </header>
  <hr />
</section>

<div class="body-container">
  <div class="right-container">
    <section class="w-full t-row">
      <h4>{{ "translate.clinics.updAddress" | translate }}</h4>

      <div class="l-flex-column t-panel no-indent">
        <!--full address-->
        <input-wrap
          label="{{ 'translate.clinics.fullAddress' | translate }}"
          cssClass="l-cell-spread"
        >
          <!-- <input
            type="text"
            [(ngModel)]="clinic.gFormattedAddress"
            class="t-input t-input--colored"
          /> -->
          <p-autoComplete
            [(ngModel)]="clinic.gFormattedAddress"
            [suggestions]="addressSuggestions"
            (completeMethod)="addressAutoComplete($event)"
            class="t-input--colored"
          ></p-autoComplete>
        </input-wrap>

        <!--address notes-->
        <input-wrap
          label="{{ 'translate.clinics.addressNotes' | translate }}"
          cssClass="l-cell-spread"
        >
          <input
            type="text"
            [(ngModel)]="clinic.addressNotes"
            class="t-input t-input--colored"
          />
        </input-wrap>
      </div>
    </section>

    <section class="w-full">
      <h4>{{ "translate.clinics.addressMmd" | translate }}</h4>

      <div class="l-flex-column t-panel no-indent">
        <!-- address-->
        <input-wrap
          label="{{ 'translate.clinics.address' | translate }}"
          cssClass="l-cell-spread"
        >
          <input
            type="text"
            [(ngModel)]="clinic.address"
            disabled="true"
            class="t-input t-input--colored"
          />
        </input-wrap>

        <!--city-->
        <input-wrap
          label="{{ 'translate.clinics.city' | translate }}"
          cssClass="l-cell-spread"
        >
          <input
            type="text"
            disabled="true"
            [(ngModel)]="clinic.city"
            class="t-input t-input--colored"
          />
        </input-wrap>
      </div>
    </section>
  </div>

  <div class="left-container">
    <section class="w-full t-row">
      <h4>{{ "translate.clinics.info" | translate }}</h4>

      <!--cli short -->
      <input-wrap
        label="{{ 'translate.clinics.cliShort' | translate }}"
        cssClass="l-cell-spread"
      >
        <input
          [disabled]="true"
          [(ngModel)]="clinic.cliShort"
          class="t-input t-input--colored"
        />
      </input-wrap>

      <!--delivery email-->
      <input-wrap
        label="{{ 'translate.general.deliveryEmail' | translate }}"
        cssClass="l-cell-spread"
      >
        <input
          type="email"
          [(ngModel)]="clinic.deliveryEmail"
          class="t-input t-input--colored"
        />
      </input-wrap>

      <!--delayAlertSw-->
      <input-wrap>
        <checkbox-wrap
          label="{{ 'translate.clinic.delayAlertSw' | translate }}"
        >
          <input type="checkbox" [(ngModel)]="clinic.delayAlertSw" />
        </checkbox-wrap>
      </input-wrap>

      <!--openFridaySw-->
      <input-wrap>
        <checkbox-wrap
          label="{{ 'translate.clinic.openFridaySw' | translate }}"
        >
          <input type="checkbox" [(ngModel)]="clinic.openFridaySw" />
        </checkbox-wrap>
      </input-wrap>
    </section>

    <div class="t-panel-cell t-buttonSet l-align-end">
      <spinner *ngIf="saving"></spinner>
      <button
        [disabled]="!allowSubmit() || saving"
        (click)="updateClinic()"
        class="t-button-outline"
      >
        {{ "translate.general.save" | translate }}
      </button>
    </div>
  </div>
</div>
